import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import "isomorphic-fetch"

import Router from "vue-router";
import Registration from "./components/Registration.vue";
import ThankYou from "./components/ThankYou.vue";
import Error from "./components/Error.vue";

Vue.config.productionTip = false

// const API = 'https://studentvote.ca/registration-api/api';
const API = 'https://studentvote.ca/registration-prov-api/api';

Vue.prototype.$API = API;
Vue.prototype.$TOKEN = 'zMN0kdhL477tWaau1Bio77yUCc4cARawBmql8Nj0';

Vue.prototype.$LANG = "EN";
// Vue.prototype.$LANG = "FR";

Vue.use(VueI18n);
Vue.use(Router);

let url = API + "/get_lang_v2";
fetch(url, {
  method: 'POST',
  body: JSON.stringify({
    "domain": window.location.origin
  }),
  //headers: new Headers({
  //  'x-api-key': this.$TOKEN
  //})
})
  .then(stream => stream.json())
  .then(response => {
    // response = 'fr';
    Vue.prototype.$LANG = response;
    loadApp(response);

  })
  .catch(_ => {
    // console.log(error);
    //console.log('ERROR getTableData: '+error)
  });

function loadApp(response) {

  let phoneNumber = "1.833.503.3366";
  if (response == 'en') {
    phoneNumber = "1-866-488-8775";
  }
  
  // response = 'fr';

  const i18n = new VueI18n({
    locale: response,
    fallbackLocale: 'en',
    messages: {
      en: {
        "site": "http://www.studentvote.ca",
        "site_en_header": "http://www.studentvote.ca/registration",
        "site_fr_header": "http://www.voteetudiant.ca/inscription",
        "tel_phone_number": "tel:" + phoneNumber,
        "phone_number": phoneNumber,
        "Register Your School": "Register Your School",
        "Step 1: Find Your School": "Step 1: Find your school",
        "Step 2: Enter your info": "Step 2: Enter your info",
        "Step 3: Review and Submit": "Step 3: Review and submit",
        "Province / Territory": "Province / Territory",
        "Select A Province": "Select A Province",
        "School Board / Division": "School board / division",
        "Select A School Board": "Select A School Board",
        "If you are an independent school, please select the option “Independent and Other” from the menu": "If you are an independent school, please select the option “Independent and Other” from the menu",
        "Select one": "Select one",
        "Select school from schools in that school board": "Select school from schools in that school board",
        "Select an option": "Select an option",
        "Please describe:": "Please describe:",
        "Step 2: Enter Your Info": "Step 2: Enter Your Info",
        "Have you been a Student Vote Team Leader before?": "Have you been a Student Vote Team Leader before?",
        "Yes": "Yes",
        "I have done Student Vote but was not the Team Leader": "I have done Student Vote but was not the Team Leader",
        "No": "No",
        "How many Student Vote programs have you been involved with?": "How many Student Vote programs have you been involved in?",
        "1 election": "1 election",
        "2 elections": "2 elections",
        "3 elections": "3 elections",
        "4 or more": "4 or more",
        "Primary contact details": "Team Leader Contact Details",
        "First Name": "First name",
        "Last Name": "Last name",
        "School E-mail address": "Email address",
        "Confirm E-mail address": "Confirm email address",
        "School phone": "Phone",
        "Language of correspondence": "Language of correspondence",
        "Secondary contact details": "Secondary contact details",
        "School information": "School information",
        "School type": "School type",
        "Select A School Type": "Select A School Type",
        "Grades to be involved": "Grades to be involved",
        "Select all that apply. Hold down the Ctrl (windows) / Command (Mac) button to select multiple options.": "Select all that apply. Hold down the Ctrl (windows) / Command (Mac) button to select multiple options.",
        "Resource Type": "Resource type",
        "Elementary": "Elementary",
        "Secondary": "Secondary",
        "Both": "Both",
        "Language of Resources": "Language of resources",
        "Language of Materials": "Language of Materials",
        "Do you require ballot boxes and voting screens?": "Do you require ballot boxes and voting screens?",
        "Please select": "Please select",
        "No, I saved mine from the last Student Vote Program": "No, I saved mine from the last Student Vote Program",
        "Maybe": "Maybe",
        "Select A District": "Select A District",
        "If you’re not sure what your riding is, click this link to Find Your Riding": "If you’re not sure what your riding is, click here",
        // "If you’re not sure what your riding is, click this link to Find Your RidingON": "",
        "If you’re not sure what your riding is, click this link to Find Your RidingALL": "If you’re not sure what your riding is, click here: Find Your Riding",
        "Number of Ballots": "Number of ballots",
        "Number of Students": "Number of students",
        "Contact Information": "Contact Information",
        "Would you like to be contacted by media for a visit or interview?": "Would you like to be contacted by media for a visit or interview?",
        "Federal Riding": "Federal Riding",
        "Federal RidingALL": "Federal Riding",
        "Previous": "Previous",
        "Next": "Next",
        "I can't remember": "I can't remember",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
        "10": "10",
        "11": "11",
        "12": "12",
        "ALL": "ALL",
        "NONE": "NONE",
        "Email Address": "Email Address",
        "Re-enter your email": "Re-enter your email",
        "Enter a number": "Enter a number",
        "School Name": "School name",
        "You have been sent a confirmation email containing all of your registration information. Please review it and inform us of any changes as early as possible.": "You have been sent a confirmation email containing all of your registration information. Please review it and inform us of any changes as soon as possible.",
        "If the message has not arrived in your mailbox, please check your junk folder or check with our team to make sure that your registration was submitted.": "If the message has not arrived in your mailbox, please check your junk folder or check with our team to make sure that your registration was submitted.",
        "If you need any assistance, please don't hesitate to contact us at 1-866-488-8775 or hello@civix.ca": "If you need any assistance, please don't hesitate to contact us at <a href=\"mailto:hello@civix.ca\" >hello@civix.ca</a>",
        "Tweet your registration": "Tweet your registration",
        "Return to Student Vote": "Return to Student Vote",
        "Student Vote Canada 2019": "Student Vote",
        "federal_riding_link": "https://www.elections.ca/scripts/vis/FindED?L=e&PAGEID=20",
        "Find your riding": "Find your riding",
        "If you cannot find your school in the list, please contact us at 1-866-488-8775 or hello@civix.ca": "If you cannot find your school in the list, please contact us <a href=\"mailto:hello@civix.ca\" >hello@civix.ca</a>",
        "English": "English",
        "French": "French",
        "Home": "Home",
        "About Student Vote": "About Student Vote",
        "Classroom Resources": "Classroom Resources",
        "Election Tools": "Election Tools",
        "Student Vote Day": "Student Vote Day",
        "News & Events": "News &#038; Events",
        "Student Vote is a program of CIVIX.": "Student Vote is a program of CIVIX.",
        "Copyright 2019 Civix Canada": "Copyright 2019 Civix Canada",
        "Student Vote Canada 2019 is made possible by Elections Canada.": "During federal elections, Student Vote Canada is presented in collaboration with Elections Canada.",
        "logo": "https://www.studentvote.ca/canada/wp-content/themes/studentvote/images/logo-StudentVote-Canada2019-EN.svg",
        "not team leader": "No, but I have participated before",
        "cant remember": "I can't Remember",
        "Submit": "Submit",
        "If you need any assistance, please don’t hesitate to contact us at 1-866-488-8775 or hello@civix.ca": "If you need any assistance, please don&rsquo;t hesitate to contact us at <a href=\"mailto:hello@civix.ca\" >hello@civix.ca</a>",
        "Thank you for your interest": "Thank you for your interest in Student Vote. {school_name} is already registered.",
        "Registration Details": "Registration Details",
        "If you would like to include your class in the riding above": "If you would like to add your class to your school's registration, please contact us at <a href='mailto://hello@civix.ca'>hello@civix.ca</a>.",
        "Team Leader": "Team Leader",
        "Registration date": "Registration date",
        "click here": "click here",
        "footer": `<a href="https://civix.ca/">www.civix.ca</a> | <a href="tel:${phoneNumber}">${phoneNumber}</a> | <a href="mailto:hello@civix.ca">hello@civix.ca</a>`,
        "footer_federal": `National Office : | <a href="tel:1.866.488.8775">1.866.488.8775</a> | <a href="mailto:hello@civix.ca">hello@civix.ca</a>`,
        "footer_qc_office_federal": `Quebec Office : | <a href="tel:1.833.503.3366 ">1.833.503.3366</a> | <a href="mailto:info@civix.quebec">info@civix.quebec</a>`,
        "civix_email": "<a href=\"mailto:hello@civix.ca\">hello@civix.ca</a>",
        "FR_English": "English",
        "This section is optional or can be added at a later date": "This section is optional or can be added at a later date",
        "click_here_to_go_back": "Not your school? Click here to go back",
        "Federal RidingMunicipalAB": "Municipality",
        "Federal RidingMunicipalBC": "Municipality",
        "Federal RidingMunicipalON": "Municipality",
        "Federal RidingMunicipalMB": "Municipality",
        "Federal RidingMunicipalNB": "Municipality",
        "Federal RidingMunicipalNL": "Municipality",
        "Federal RidingMunicipalNS": "Municipality",
        "Federal RidingMunicipalNT": "Municipality",
        "Federal RidingMunicipalNU": "Municipality",
        "Federal RidingMunicipalPE": "Municipality",
        "Federal RidingMunicipalQC": "Municipality",
        "Federal RidingMunicipalSK": "Constituency",
        "Federal RidingMunicipalYT": "Municipality",
        "Federal RidingFederalAB": "Electoral District",
        "Federal RidingFederalBC": "Electoral District",
        "Federal RidingFederalON": "Electoral District",
        "Federal RidingFederalMB": "Electoral Division",
        "Federal RidingFederalNB": "Electoral District",
        "Federal RidingFederalNL": "Electoral District",
        "Federal RidingFederalNS": "Electoral District",
        "Federal RidingFederalNT": "Electoral District",
        "Federal RidingFederalNU": "Electoral District",
        "Federal RidingFederalPE": "Electoral District",
        "Federal RidingFederalQC": "Electoral District",
        "Federal RidingFederalSK": "Constituency",
        "Federal RidingFederalYT": "Electoral District",
        "Federal RidingProvincialAB": "Electoral District",
        "Federal RidingProvincialBC": "Electoral District",
        "Federal RidingProvincialON": "Electoral District",
        "Federal RidingProvincialMB": "Electoral Division",
        "Federal RidingProvincialNB": "Electoral District",
        "Federal RidingProvincialNL": "Electoral district",
        "Federal RidingProvincialNS": "Electoral District",
        "Federal RidingProvincialNT": "Electoral District",
        "Federal RidingProvincialNU": "Electoral District",
        "Federal RidingProvincialPE": "Electoral District",
        "Federal RidingProvincialQC": "Electoral District",
        "Federal RidingProvincialSK": "Constituency",
        "Federal RidingProvincialYT": "Electoral district",
        "School District Sub-districtAB": "School District Sub-district",
        "School District Sub-districtBC": "School District Sub-district",
        "School District Sub-districtON": "School District Sub-district",
        "School District Sub-districtMB": "School District Sub-district",
        "School District Sub-districtNB": "School District Sub-district",
        "School District Sub-districtNL": "School District Sub-district",        
        "School District Sub-districtNS": "School District Sub-district",
        "School District Sub-districtNT": "School District Sub-district",
        "School District Sub-districtNU": "School District Sub-district",
        "School District Sub-districtPE": "School District Sub-district",
        "School District Sub-districtQC": "School District Sub-district",
        "School District Sub-districtSK": "School District Sub-district",
        "School District Sub-districtYT": "School District Sub-district",
        "School District Sub-district": "School District Sub-district",
        "If you’re not sure what your riding is, click this link to Find Your RidingAB": "Click here to see municipal boundaries",
        "If you’re not sure what your riding is, click this link to Find Your RidingBC": "",
        "If you’re not sure what your riding is, click this link to Find Your RidingON": "Click here to view the municipal boundary maps",
        "If you’re not sure what your riding is, click this link to Find Your RidingMB": "Click here to view the municipal boundary maps",
        "If you’re not sure what your riding is, click this link to Find Your RidingNB": "Click here to view the municipal boundaries",
        "If you’re not sure what your riding is, click this link to Find Your RidingNS": "If you're not sure, click this link to find your school's electoral district",
        "If you’re not sure what your riding is, click this link to Find Your RidingNT": "If you're not sure, click this link to find your school's electoral district",
        "If you’re not sure what your riding is, click this link to Find Your RidingNU": "If you're not sure, click this link to find your school's electoral district",
        "If you’re not sure what your riding is, click this link to Find Your RidingNL": "If you're not sure, click this link to find your school's electoral district",
        "If you’re not sure what your riding is, click this link to Find Your RidingPE": "If you're not sure, click this link to find your school's electoral district",
        "If you’re not sure what your riding is, click this link to Find Your RidingQC": "If you're not sure, click this link to find your school's electoral district",
        "If you’re not sure what your riding is, click this link to Find Your RidingSK": "Please note that the constituencies have changed for the election. Click to find your constituency",
        "If you’re not sure what your riding is, click this link to Find Your RidingYT": "Please note that there are new electoral districts for the 2025 election. Click here to find your 2025 electoral district.",
        "federal_riding_linkAB": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkBC": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkON": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkMB": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkNB": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkNL": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkNS": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkNT": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkNU": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkPE": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkQC": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkSK": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkYT": "https://www.elections.sk.ca/voters/gis/",
        "logo_png_old": process.env.BASE_URL + "assets/images/StudentVote-Logo-White.png",
        "logo_png": process.env.BASE_URL + "assets/images/SV2021_english_transparent.png",
        "logo_pngBC": process.env.BASE_URL + "assets/images/SV_BC2024_White.png",

        "How did you hear about Student Vote Canada 2019?": "How did you hear about {election_name}?",
        "How did you hear about Student Vote Canada 2019?ALL": "How did you hear about {election_name} this year?",
        "How did you hear about Student Vote Canada 2019?AB": "How did you hear about Student Vote for the 2025 Alberta municipal elections?",
        "How did you hear about Student Vote Canada 2019?BC": "How did you hear about the {election_name}?",
        "How did you hear about Student Vote Canada 2019?ON": "How did you hear about the 2026 {election_name}?",
        "How did you hear about Student Vote Canada 2019?MB": "How did you hear about the 2026 {election_name}?",
        "How did you hear about Student Vote Canada 2019?NB": "How did you hear about the {election_name}?",
        "How did you hear about Student Vote Canada 2019?NL": "How did you hear about {election_name}?",
        "How did you hear about Student Vote Canada 2019?NS": "How did you hear about this year's {election_name}?",
        "How did you hear about Student Vote Canada 2019?NT": "How did you hear about this year's {election_name}?",
        "How did you hear about Student Vote Canada 2019?NU": "How did you hear about this year's {election_name}?",
        "How did you hear about Student Vote Canada 2019?PE": "How did you hear about {election_name}?",
        "How did you hear about Student Vote Canada 2019?QC": "How did you hear about {election_name}?",
        "How did you hear about Student Vote Canada 2019?SK": "How did you hear about {election_name}?",
        "How did you hear about Student Vote Canada 2019?YT": "How did you hear about {election_name}?",
        "Thank you for registering for": "Thank you for registering for {election_name}",
        "Thank you for registering forALL": "Thank you for registering for {election_name}",
        "Thank you for registering forAB": "Thank you for registering for Student Vote for the 2025 Alberta municipal elections",
        "Thank you for registering forBC": "Thank you for registering for {election_name}",
        "Thank you for registering forON": "Thank you for registering for the 2026 {election_name}",
        "Thank you for registering forMB": "Thank you for registering for the 2026 {election_name}",
        "Thank you for registering forNB": "Thank you for registering for {election_name}",
        "Thank you for registering forNL": "Thank you for registering for {election_name}",
        "Thank you for registering forNS": "Thank you for registering for {election_name}",
        "Thank you for registering forNT": "Thank you for registering for {election_name}",
        "Thank you for registering forNU": "Thank you for registering for {election_name}",
        "Thank you for registering forPE": "Thank you for registering for {election_name}",
        "Thank you for registering forQC": "Thank you for registering for {election_name}",
        "Thank you for registering forSK": "Thank you for registering for {election_name}",
        "Thank you for registering forYT": "Thank you for registering for {election_name}",
        "Electoral District": "Electoral District",
        "Electoral DistrictALL": "Electoral District",
        "Electoral DistrictAB": "Municipality",
        "Electoral DistrictBC": "Local Government",
        "Electoral DistrictON": "Municipality",
        "Electoral DistrictMB": "Electoral Division",
        "Electoral DistrictNB": "Electoral District",
        "Electoral DistrictNL": "Municipality",
        "Electoral DistrictNS": "Municipality",
        "Electoral DistrictNT": "Electoral District",
        "Electoral DistrictNU": "Electoral District",
        "Electoral DistrictPE": "Electoral District",
        "Electoral DistrictQC": "Municipality",
        "Electoral DistrictSK": "Constituency",
        "Electoral DistrictYT": "Electoral district",

        "To register this school for a different electoral district than  listed above": "To register this school for a <b>different electoral district</b> than listed above, ",
        "To register this school for a different electoral district than  listed aboveALL": "To register this school for a <b>different electoral district</b> than listed above, ",

        "To register this school for a different electoral district than  listed aboveAB": "To register this school for a <b>different electoral district</b> than listed above, ",
        "To register this school for a different electoral district than  listed aboveON": "To register this school for a <b>different electoral district</b> than listed above, ",
        "To register this school for a different electoral district than  listed aboveMB": "To register this school for a <b>different electoral district</b> than listed above, ",
        "To register this school for a different electoral district than  listed aboveNL": "To register this school for a <b>different electoral district</b> than listed above, ",
        "To register this school for a different electoral district than  listed aboveNT": "To register this school for a <b>different electoral district</b> than listed above, ",
        "To register this school for a different electoral district than  listed aboveNU": "To register this school for a <b>different electoral district</b> than listed above, ",
        "To register this school for a different electoral district than  listed abovePE": "To register this school for a <b>different electoral district</b> than listed above, ",
        "To register this school for a different electoral district than  listed aboveQC": "To register this school for a <b>different electoral district</b> than listed above, ",
        
        "To register this school for a different electoral district than  listed aboveBC": "To register this school for a different electoral district than listed above,  ",
        "To register this school for a different electoral district than  listed aboveNS": "To register this school for a different municipality than listed above, ",
        
        "To register this school for a different electoral district than  listed aboveNB": "To register this school for a different electoral district than listed above, please create a new registration with the desired electoral district. ",
        "To register this school for a different electoral district than  listed aboveSK": "To register this school for a different constituency than listed above, please create a new registration with the desired constituency. ",
        "To register this school for a different electoral district than  listed aboveYT": "To register this school for a <b>different electoral district</b> than listed above, ",
        "Please use format 555-555-5555": "Please use format 555-555-5555",
        "If you would like to ensure your class can also participate, please do the following:": "If you would like to ensure your class can also participate, please do the following:",
        "step_1_error": "<b>Step 1</b>: Check with the Team Leader to find out if the current registration includes your class",
        "step_2_error": "<b>Step 2</b>: To add your class to your school’s registration or to receive communications about this election, please email us at <a href='mailto:hello@civix.ca'>hello@civix.ca</a>. Please include your province, school name, and (if applicable) the number of additional ballots you wish to add.",
        "step_3_error": "<b>Step 3</b>: If you would like to receive email updates about materials and resources available for this program, please <a href='http://eepurl.com/hTLjZn'>subscribe to the {election_name} contact list.</a>",
        "How would you like to receive information about resources and updates to" : "How would you like to receive information about resources and updates to {election_name}?",
        "Email": "Email",
        "Phone call": "Phone call",
        "Text message (please ensure number above corresponds to a mobile phone)": "Text message (please ensure number above corresponds to a mobile phone)",
        "Text message": "Text message",
        "Select all that apply": "Select all that apply",
        "Click here to find your 2024 electoral district": "Click here to find your electoral distric"
      },
      fr: {
        "tel_phone_number": "tel:" + phoneNumber,
        "phone_number": phoneNumber,
        "Register Your School": "Inscrivez votre école",
        "Step 1: Find Your School": "1re étape : Trouvez votre école",
        "Step 2: Enter your info": "2e étape : Entrez vos informations",
        "Step 3: Review and Submit": "3e étape : Révisez et soumettez",
        "Province / Territory": "Province / Territoire",
        "Select A Province": "Choisissez une province",
        "School Board / Division": "Conseil / division scolaire",
        "Select A School Board": "Choisissez un conseil / Centre de services scolaire",
        "If you are an independent school, please select the option “Independent and Other” from the menu": "Si vous êtes une école indépendante, veuillez choisir l’option \"Indépendante et autre\" dans le menu",
        "Select one": "Choisissez une option",
        "Select school from schools in that school board": "Choisissez l’école dans les écoles dans ce conseil / commission scolaire",
        "Select an option": "Choisissez une option",
        "Please describe:": "Veuillez préciser:",
        "Step 2: Enter Your Info": "2e étape : Entrez vos informations",
        "Have you been a Student Vote Team Leader before?": "Avez-vous déjà été chef d'équipe dans le cadre du programme Vote étudiant?",
        "Yes": "Oui",
        "I have done Student Vote but was not the Team Leader": "Non mais j’ai déjà participé",
        "No": "Non",
        "How many Student Vote programs have you been involved with?": "À combien de programmes du Vote étudiant avez-vous participé?",
        "1 election": "1 élection",
        "2 elections": "2 élections",
        "3 elections": "3 élections",
        "4 or more": "4 ou plus",
        "Primary contact details": "Coordonnées du / de la chef d’équipe",
        "First Name": "Prénom",
        "Last Name": "Nom",
        "School E-mail address": "Courriel principal",
        "Confirm E-mail address": "Entrez à nouveau le courriel principal",
        "School phone": "Téléphone à l’école",
        "Language of correspondence": "Langue de correspondance",
        "Language of Materials": "Language of Materials",
        "English": "Anglais",
        "French": "Français",
        "Secondary contact details": "Coordonnées D’une Seconde Personne-ressource À Votre École",
        "School information": "Information sur l'école",
        "School type": "Type d’école",
        "Select A School Type": "Choisissez le type d’école",
        "Grades to be involved": "Niveau(x) scolaire(s) des élèves qui participent",
        "Select all that apply. Hold down the Ctrl (windows) / Command (Mac) button to select multiple options.": "Choisissez tous ceux qui s’appliquent. Maintenez la touche CTRL (windows) / Command (Mac) enfoncée afin de choisir plusieurs options.",
        "Resource Type": "Type de ressource",
        "Elementary": "Primaire / Élémentaire",
        "Secondary": "Intermédiaire / Secondaire",
        "Both": "Les deux",
        "Language of Resources": "Langue des ressources",
        "Do you require ballot boxes and voting screens?": "Avez-vous besoin d'urnes et d'isoloirs?",
        "Please select": "Choisissez s’il vous plaît",
        "No, I saved mine from the last Student Vote Program": "Non, j’ai conservé ceux des dernières élections",
        "Maybe": "Peut-être",
        "Select A District": "Choisissez une circonscription électorale",
        "Number of Ballots": "Nombre de bulletins de vote",
        "Number of Students": "Nombre d'élèves participants",
        "Contact Information": "Coordonnées",
        "Would you like to be contacted by media for a visit or interview?": "Souhaitez-vous être contacté(e) par les médias pour une visite ou une entrevue?",
        "Federal Riding": "Circonscription électorale",
        "Federal RidingALL": "Circonscription électorale",
        "Previous": "Précédent",
        "Next": "Suivant",
        "I can't remember": "Je ne sais pas",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
        "10": "10",
        "11": "11",
        "12": "12",
        "ALL": "TOUS",
        "NONE": "AUCUN",
        "Email Address": "Adresse Courriel",
        "Re-enter your email": "Entrez à nouveau votre adresse courriel",
        "Enter a number": "Entrez un chiffre",
        "School Name": "Nom de l'école",
        "You have been sent a confirmation email containing all of your registration information. Please review it and inform us of any changes as early as possible.": "Nous vous avons envoyé un courriel de confirmation qui contient toute l'information qui a trait à votre inscription. Veuillez réviser le courriel et nous contacter le plus rapidement possible s'il y a des changements à apporter à votre inscription.",
        "If the message has not arrived in your mailbox, please check your junk folder or check with our team to make sure that your registration was submitted.": "Si ce message ne se trouve pas dans votre boite de réception, veuillez s'il vous plait vérifier vos pourriels ou contactez notre équipe afin que nous vérifions que nous avons bien reçu votre inscription.",
        "If you need any assistance, please don't hesitate to contact us at 1-866-488-8775 or hello@civix.ca": "Si vous avez des questions, n'hésitez pas à nous contacter à <a href=\"mailto:salut@civix.ca\" >salut@civix.ca</a>",
        "Return to Student Vote": "Retournez au Vote étudiant",
        "Student Vote Canada 2019": "Vote étudiant",
        "federal_riding_link": "https://www.elections.ca/scripts/vis/FindED?L=f&PAGEID=20",
        "Find your riding": "Trouver votre circonscription",
        "If you cannot find your school in the list, please contact us at 1-866-488-8775 or hello@civix.ca": "Si vous ne pouvez pas trouver votre école dans la liste, veuillez nous contacter à <a href=\"mailto:salut@civix.ca\" >salut@civix.ca</a>",
        "Home": "Home",
        "About Student Vote": "About Student Vote",
        "Classroom Resources": "Classroom Resources",
        "Election Tools": "Election Tools",
        "Student Vote Day": "Student Vote Day",
        "News & Events": "News &#038; Events",
        "Student Vote is a program of CIVIX.": "Vote étudiant est un programme de CIVIX.",
        "Copyright 2019 Civix Canada": "Tous droits réservés 2019 CIVIX Canada",
        "Student Vote Canada 2019 is made possible by Elections Canada.": "Lors des élections fédérales, le programme Vote Étudiant Canada vous est présenté en collaboration avec Élections Canada.",
        "logo": "https://www.studentvote.ca/canada/wp-content/themes/studentvote/images/logo-StudentVote-Canada2019-FR.svg",
        "not team leader": "Non, mais j'ai déjà participé",
        "cant remember": "Je ne sais pas",
        "Submit": "Soumettre",
        "If you need any assistance, please don’t hesitate to contact us at 1-866-488-8775 or hello@civix.ca": "Si vous avez besoin d’aide, n’hésitez pas à communiquer avec nous au <a href=\"mailto:salut@civix.ca\" >salut@civix.ca</a>",
        "Tweet your registration": "Tweetez votre inscription",
        "Thank you for your interest": "MERCI DE VOTRE INTÉRÊT POUR LE PROGRAMME VOTE ÉTUDIANT. CEPENDANT, VOTRE ÉCOLE { school_name } S'EST DÉJÀ INSCRITE.",
        "Registration Details": "DÉTAILS DE VOTRE INSCRIPTION",
        "If you would like to include your class in the riding above": `Si vous désirez ajouter votre classe à la circonscription ci-dessus, svp rejoignez-nous en nous par courriel au <a href='mailto://salut@civix.ca'>salut@civix.ca</a> ou en appelant le ${phoneNumber}.`,
        "Team Leader": "Chef d’équipe",
        "Registration date": "Enregistré",
        "click here": "cliquer ici",
        "footer": `Bureau du Canada : | <a href="tel:${phoneNumber}">${phoneNumber}</a> | <a href="mailto:salut@civix.ca">salut@civix.ca</a>`,
        "footer_qc_office": `Bureau du Québec : | <a href="tel:${phoneNumber}">${phoneNumber}</a> | <a href="mailto:info@civix.quebec">info@civix.quebec</a>`,
        "footer_federal": `Bureau du Canada : | <a href="tel:1.866.488.8775">1.866.488.8775</a> | <a href="mailto:salut@civix.ca">salut@civix.ca</a>`,
        "footer_qc_office_federal": `Bureau du Québec : | <a href="tel:1.833.503.3366 ">1.833.503.3366</a> | <a href="mailto:info@civix.quebec">info@civix.quebec</a>`,
        "civix_email": "<a href=\"mailto:salut@civix.ca\">salut@civix.ca</a>",
        "FR_English": "Anglais",
        "This section is optional or can be added at a later date": "Cette section est optionnelle ou peut être remplie plus tard",
        "click_here_to_go_back": "Ce n'est pas votre école? Cliquez ici pour retourner à la page précédente.",

        "Federal RidingMunicipalAB": "Circonscription",
        "Federal RidingMunicipalBC": "Municipalité",
        "Federal RidingMunicipalON": "Municipalité",
        "Federal RidingMunicipalMB": "Circonscription électorale",
        "Federal RidingMunicipalNB": "Municipalité",
        "Federal RidingMunicipalNL": "Municipalité",
        "Federal RidingMunicipalNS": "Municipalité",
        "Federal RidingMunicipalNT": "Municipalité",
        "Federal RidingMunicipalNU": "Circonscription",
        "Federal RidingMunicipalPE": "Municipalité",
        "Federal RidingMunicipalQC": "Municipalité",
        "Federal RidingMunicipalSK": "Circonscription électorale",
        "Federal RidingMunicipalYT": "Circonscription",
        "Federal RidingFederalAB": "Circonscription",
        "Federal RidingFederalBC": "Circonscription",
        "Federal RidingFederalON": "Circonscription",
        "Federal RidingFederalMB": "Circonscription électorale",
        "Federal RidingFederalNB": "Circonscription électorale",
        "Federal RidingFederalNL": "Circonscription",
        "Federal RidingFederalNS": "Circonscription",
        "Federal RidingFederalNT": "Circonscription",
        "Federal RidingFederalNU": "Circonscription",
        "Federal RidingFederalPE": "Circonscription",
        "Federal RidingFederalQC": "Circonscription",
        "Federal RidingFederalSK": "Circonscription électorale",
        "Federal RidingFederalYT": "Circonscription",
        "Federal RidingProvincialAB": "Circonscription",
        "Federal RidingProvincialBC": "Circonscription",
        "Federal RidingProvincialON": "Circonscription",
        "Federal RidingProvincialMB": "Circonscription électorale",
        "Federal RidingProvincialNB": "Circonscription électorale",
        "Federal RidingProvincialNL": "Circonscription",
        "Federal RidingProvincialNS": "Circonscription",
        "Federal RidingProvincialNT": "Circonscription",
        "Federal RidingProvincialNU": "Circonscription",
        "Federal RidingProvincialPE": "Circonscription",
        "Federal RidingProvincialQC": "Circonscription",
        "Federal RidingProvincialSK": "Circonscription électorale",
        "Federal RidingProvincialYT": "Circonscription",

        "If you’re not sure what your riding is, click this link to Find Your RidingAB": "Cliquez ici pour voir les limites municipales",
        "If you’re not sure what your riding is, click this link to Find Your RidingBC": "Cliquez ici pour trouver votre circonscription (disponsible seulement en anglais)",
        "If you’re not sure what your riding is, click this link to Find Your RidingON": "Cliquez ici pour voir la carte des limites municipales.",
        "If you’re not sure what your riding is, click this link to Find Your RidingMB": "Cliquez ici pour voir la carte des limites municipales (disponible seulement en anglais).",
        "If you’re not sure what your riding is, click this link to Find Your RidingNB": "Trouvez votre municipalité.",
        "If you’re not sure what your riding is, click this link to Find Your RidingNS": "Trouvez votre circonscription.",
        "If you’re not sure what your riding is, click this link to Find Your RidingNT": "Trouvez votre circonscription.",
        "If you’re not sure what your riding is, click this link to Find Your RidingNU": "Trouvez votre circonscription.",
        "If you’re not sure what your riding is, click this link to Find Your RidingNL": "Trouvez votre circonscription.",
        "If you’re not sure what your riding is, click this link to Find Your RidingPE": "Trouvez votre circonscription.",
        "If you’re not sure what your riding is, click this link to Find Your RidingQC": "Trouvez votre circonscription.",
        "If you’re not sure what your riding is, click this link to Find Your RidingSK": "Veuillez noter que les circonscriptions ont changé pour l’élection de 2024. Cliquez ici pour trouver votre circonscription électorale",
        "If you’re not sure what your riding is, click this link to Find Your RidingYT": "Trouvez votre circonscription.",
        "If you’re not sure what your riding is, click this link to Find Your Riding": "Si vous n’êtes pas sûr de votre circonscription, cliquez sur le lien pour trouver votre circonscription",
        "If you’re not sure what your riding is, click this link to Find Your RidingALL": "Si vous n’êtes pas sûr de votre circonscription, cliquez sur le lien pour trouver votre circonscription",

        "federal_riding_linkAB": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkBC": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkON": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkMB": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkNB": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkNL": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkNS": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkNT": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkNU": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkPE": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkQC": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkSK": "https://www.elections.sk.ca/voters/gis/",
        "federal_riding_linkYT": "https://www.elections.sk.ca/voters/gis/",

        "logo_png_old": process.env.BASE_URL + "assets/images/VoteEtudiant-Logo-White.png",
        "logo_png": process.env.BASE_URL + "assets/images/VE2021_french_transparent.png",
        "logo_pngBC": process.env.BASE_URL + "assets/images/VE_BC2024_White.png",
        

        
        "How did you hear about Student Vote Canada 2019?": "Comment avez-vous entendu parler du {election_name}?",
        "How did you hear about Student Vote Canada 2019?ALL": "Comment avez-vous entendu parler du {election_name}?",
        "How did you hear about Student Vote Canada 2019?AB": "Comment avez-vous entendu parler du {election_name}?",
        "How did you hear about Student Vote Canada 2019?BC": "Comment avez-vous entendu parler du {election_name}?",
        "How did you hear about Student Vote Canada 2019?ON": "Comment avez-vous entendu parler du {election_name} 2026?",
        "How did you hear about Student Vote Canada 2019?MB": "Comment avez-vous entendu parler du {election_name} 2026?",
        "How did you hear about Student Vote Canada 2019?NB": "Comment avez-vous entendu parler du {election_name}?",
        "How did you hear about Student Vote Canada 2019?NL": "Comment avez-vous entendu parler du {election_name}?",
        "How did you hear about Student Vote Canada 2019?NS": "Comment avez-vous entendu parler du {election_name}?",
        "How did you hear about Student Vote Canada 2019?NT": "Comment avez-vous entendu parler du {election_name}?",
        "How did you hear about Student Vote Canada 2019?NU": "Comment avez-vous entendu parler du {election_name}?",
        "How did you hear about Student Vote Canada 2019?PE": "Comment avez-vous entendu parler du {election_name}?",
        "How did you hear about Student Vote Canada 2019?QC": "Comment avez-vous entendu parler du {election_name}?",
        "How did you hear about Student Vote Canada 2019?SK": "Comment avez-vous entendu parler du {election_name}?",
        "How did you hear about Student Vote Canada 2019?YT": "Comment avez-vous entendu parler du {election_name}?",

        "Thank you for registering for": "Merci d'avoir complété votre inscription au {election_name}",
        "Thank you for registering forALL": "Merci d'avoir complété votre inscription au {election_name}",
        "Thank you for registering forAB": "Merci d'avoir complété votre inscription au {election_name}",
        "Thank you for registering forBC": "Merci d'avoir complété votre inscription au programme {election_name}",
        "Thank you for registering forON": "Merci d'avoir complété votre inscription au {election_name} 2026",
        "Thank you for registering forMB": "Merci d'avoir complété votre inscription au {election_name} 2026",
        "Thank you for registering forNB": "Merci d'avoir complété votre inscription au {election_name}",
        "Thank you for registering forNL": "Merci d'avoir complété votre inscription au {election_name}",
        "Thank you for registering forNS": "Merci d'avoir complété votre inscription au {election_name}",
        "Thank you for registering forNT": "Merci d'avoir complété votre inscription au {election_name}",
        "Thank you for registering forNU": "Merci d'avoir complété votre inscription au {election_name}",
        "Thank you for registering forPE": "Merci d'avoir complété votre inscription au {election_name}",
        "Thank you for registering forQC": "Merci d'avoir complété votre inscription au {election_name}",
        "Thank you for registering forSK": "Merci d'avoir complété votre inscription au {election_name}",
        "Thank you for registering forYT": "Merci d'avoir complété votre inscription au {election_name}",

        "Electoral District": "Circonscription électorale",
        "Electoral DistrictALL": "Circonscription électorale",
        "Electoral DistrictAB": "Circonscription",
        "Electoral DistrictBC": "Municipalité",
        "Electoral DistrictON": "Circonscription électorale",
        "Electoral DistrictMB": "Circonscription électorale",
        "Electoral DistrictNB": "Circonscription électorale",
        "Electoral DistrictNL": "Circonscription",
        "Electoral DistrictNS": "Circonscription électorale",
        "Electoral DistrictNT": "Circonscription électorale",
        "Electoral DistrictNU": "Circonscription",
        "Electoral DistrictPE": "Circonscription électorale",
        "Electoral DistrictQC": "Circonscription électorale",
        "Electoral DistrictSK": "Circonscription électorale",
        "Electoral DistrictYT": "Circonscription électorale",

        "To register this school for a different electoral district than  listed above": "Pour inscrire votre &eacute;cole pour un <b>district &eacute;lectoral</b> diff&eacute;rent de celui qui est indiqu&eacute; ci-dessus, ",
        "To register this school for a different electoral district than  listed aboveALL": "Pour inscrire cette école dans une <b>circonscription électorale différente</b> que celle indiquée ci-dessus veuillez ",
        "To register this school for a different electoral district than  listed aboveAB": "Pour inscrire votre &eacute;cole pour un <b>district &eacute;lectoral</b> diff&eacute;rent de celui qui est indiqu&eacute; ci-dessus, ",
        "To register this school for a different electoral district than  listed aboveON": "Pour inscrire votre &eacute;cole pour un <b>district &eacute;lectoral</b> diff&eacute;rent de celui qui est indiqu&eacute; ci-dessus, ",
        "To register this school for a different electoral district than  listed aboveMB": "Pour inscrire votre &eacute;cole pour un <b>district &eacute;lectoral</b> diff&eacute;rent de celui qui est indiqu&eacute; ci-dessus, ",
        "To register this school for a different electoral district than  listed aboveNL": "Pour inscrire votre &eacute;cole pour un <b>district &eacute;lectoral</b> diff&eacute;rent de celui qui est indiqu&eacute; ci-dessus, ",
        "To register this school for a different electoral district than  listed aboveNT": "Pour inscrire votre &eacute;cole pour un <b>district &eacute;lectoral</b> diff&eacute;rent de celui qui est indiqu&eacute; ci-dessus, ",
        "To register this school for a different electoral district than  listed aboveNU": "Pour inscrire votre &eacute;cole pour un <b>district &eacute;lectoral</b> diff&eacute;rent de celui qui est indiqu&eacute; ci-dessus, ",
        "To register this school for a different electoral district than  listed abovePE": "Pour inscrire votre &eacute;cole pour un <b>district &eacute;lectoral</b> diff&eacute;rent de celui qui est indiqu&eacute; ci-dessus, ",
        "To register this school for a different electoral district than  listed aboveQC": "Pour inscrire votre &eacute;cole pour un <b>district &eacute;lectoral</b> diff&eacute;rent de celui qui est indiqu&eacute; ci-dessus, ",

        "To register this school for a different electoral district than  listed aboveBC": "Pour inscrire cette école pour un district électoral différent de celui qui est indiqué ci-dessus, ",
        "To register this school for a different electoral district than  listed aboveNS": "Pour inscrire cette école pour un district électoral différent de celui qui est indiqué ci-dessus, ",

        "To register this school for a different electoral district than  listed aboveNB": "Pour inscrire cette école pour un district électoral différent de celui qui est indiqué ci-dessus, ",
        "To register this school for a different electoral district than  listed aboveSK": "Pour inscrire cette école pour un district électoral différent de celui qui est indiqué ci-dessus, ",
        "To register this school for a different electoral district than  listed aboveYT": "Pour inscrire votre &eacute;cole pour un <b>district &eacute;lectoral</b> diff&eacute;rent de celui qui est indiqu&eacute; ci-dessus, ",

        
        "School District Sub-districtAB": "Sous-district scolaire",
        "School District Sub-districtBC": "Sous-district scolaire",
        "School District Sub-districtON": "Sous-district scolaire",
        "School District Sub-districtMB": "Sous-district scolaire",
        "School District Sub-districtNB": "Sous-district scolaire",
        "School District Sub-districtNL": "Sous-district scolaire",
        "School District Sub-districtNS": "Sous-district scolaire",
        "School District Sub-districtNT": "Sous-district scolaire",
        "School District Sub-districtNU": "Sous-district scolaire",
        "School District Sub-districtPE": "Sous-district scolaire",
        "School District Sub-districtQC": "Sous-district scolaire",
        "School District Sub-districtSK": "Sous-district scolaire",
        "School District Sub-districtYT": "Sous-district scolaire",
        "School District Sub-district": "Sous-district scolaire",

        "Please use format 555-555-5555": "Veuillez utiliser le format 555-555-5555",
        "If you would like to ensure your class can also participate, please do the following:": "Si vous souhaitez vous assurer que votre classe peut également participer, veuillez procéder comme suit:",
        "step_1_error": "<b>Étape 1</b>: Vérifiez auprès du/de la chef·fe d'équipe pour savoir si l'inscription actuelle inclut votre classe.",
        "step_2_error": "<b>Étape 2</b>: Pour ajouter votre classe à l’inscription de votre école, ou pour recevoir des informations par courriel au sujet de cette élection, veuillez nous écrire au <a href='mailto://salut@civix.ca'>salut@civix.ca</a> en indiquant votre province, le nom de votre école et, le cas échéant,  le nombre de bulletins de vote que vous souhaitez ajouter.",
        "step_3_error": "<b>Étape 3</b>: Si vous souhaitez recevoir des mises à jour par courriel concernant le matériel et les ressources disponibles pour ce programme, <a href='http://eepurl.com/hTLjZn'> veuillez vous inscrire à la liste de contacts de {election_name}.</a>",
        "site": "http://www.voteetudiant.ca",
        "site_en_header": "http://www.studentvote.ca/registration",
        "site_fr_header": "http://www.voteetudiant.ca/inscription",

        "How would you like to receive information about resources and updates to" : "Comment aimeriez-vous recevoir des informations sur les ressources et les nouvelles concernant {election_name}?",
        "Email": "Courriel",
        "Phone call": "Appel téléphonique",
        "Text message (please ensure number above corresponds to a mobile phone)": "Message text (veuillez vous assurer que le numéro ci-dessus correspond à un téléphone mobile)",
        "Text message": "Message texte",
        "Select all that apply": "Sélectionnez toutes les réponses qui s'appliquent",
        "Click here to find your 2024 electoral district": "Trouvez votre circonscription"


      }
    }
  });

  const titleEl = document.querySelector('head title');
  titleEl.textContent = i18n.t('Student Vote Canada 2019');

  var electionType = "federal";
  // var base = "/canada_registration";
  // if (response == "fr") {
  //   base = "/inscription_canada";
  // }

  electionType = "provincial";
  var base = "/registration";
  if (response == "fr") {
    base = "/inscription";
  }

  Vue.prototype.$ELECTIONTYPE = electionType;

  // Vue.prototype.$LANG = response;

  // console.log(this.$LANG);

  const router = new Router({
    mode: 'history',
    hash: false,
    base: base,
    routes: [
      {
        path: "/thankyou",
        name: "thankyou",
        component: ThankYou,
        props: true
      },
      {
        path: "/merci",
        name: "merci",
        component: ThankYou,
        props: true
      },
      {
        path: "/:provinceSlug?/:electionTypeSlug?",
        name: "registration",
        component: Registration,
        props: true
      },
      {
        path: "/",
        name: "error",
        component: Error,
        props: true
      },
      {
        path: "*",
        redirect: "/"
      } // catch all use case
    ]
  });

  new Vue({
    el: '#app',
    router,
    i18n,
    render: h => h(App),
  }).$mount('#app')
}
